import { render, staticRenderFns } from "./VentilationWall.vue?vue&type=template&id=552cf72b&scoped=true&"
import script from "./VentilationWall.vue?vue&type=script&lang=js&"
export * from "./VentilationWall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552cf72b",
  null
  
)

export default component.exports